/*
 * Created on Wed Oct 11 2023 4:56:55 PM
 *
 * ***************************************************************************************
 * Copyright (c) AVPS Technologies Inc 2023 
 *
 * All Rights Reserved
 * Unpublished rights are reserved under the copyright laws of the United States.
 * The software contained in this media is proprietary to and embodies confidential
 * the technology of AVPS Technologies Inc. Possession, use, duplication or
 * dissemination of the software and media is authorized only pursuant to a valid
 * written license from AVPS Technologies Inc.
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * RESTRICTED RIGHTS LEGEND Use, duplication, or disclosure by the U.S. Government
 * is subject to restrictions as set forth in Subparagraph (c) (1) (ii) of DFARS
 * 252.227-7013 or in FAR 52.227-19, as applicable.
 ****************************************************************************************
 */

import { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const ProductDescription = ({ description }) => {
  const [showFullDesc, setShowFullDesc] = useState(false);

  const stripHtml = (html = '') => {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
  };

  if (!description) return null;

  if (showFullDesc) {
    return (
      <div className="mt-3 p-4 bg-slate-50 border border-slate-200 rounded-lg text-sm text-slate-700 leading-relaxed">
        {stripHtml(description)}
        <button
          onClick={() => setShowFullDesc(false)}
          className="mt-3 flex items-center gap-1 text-blue-600 text-sm font-medium hover:underline"
        >
          Hide details <ChevronUp className="w-4 h-4" />
        </button>
      </div>
    );
  }

  return (
    <button
      onClick={() => setShowFullDesc(true)}
      className="flex items-center gap-1 text-blue-600 text-sm font-medium hover:underline"
    >
      View details <ChevronDown className="w-4 h-4" />
    </button>
  );
};

export default ProductDescription;